import { connect } from 'react-redux';

import { isUserLoggedIn } from 'apps/user/helpers';
import { search, clear, update, getSearchSuggestions, setSearchSuggestionAsSelected,
  setNextSearchSuggestionAsSelected, setPreviousSearchSuggestionAsSelected } from '../actions/search';
import HeaderSearch from 'apps/header/components/HeaderSearch';

// TODO add redirects - this is only basic search
export default connect(
  (state, ownProps) => ({
    betaFeatures: state.user.betaFeatures,
    searchSuggestionsList: state.header.search.searchSuggestions.suggestions,
    searchSuggestionsTerm: state.header.search.searchSuggestions.searchTerm,
    showMultiSearch: !ownProps.showSimpleMultiSearch && isUserLoggedIn(state.user),
    value: state.header.search.value,
  }), {
    clear,
    getSearchSuggestions,
    search,
    setNextSearchSuggestionAsSelected,
    setPreviousSearchSuggestionAsSelected,
    setSearchSuggestionAsSelected,
    update,
  }
)(HeaderSearch);
